import React, { Component } from 'react';
import $ from 'jquery';
import { Link } from 'react-router';
import Swiper from 'react-id-swiper';
import ReactSwipe from 'react-swipe';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class BannerAds extends Component
{
  constructor(props)
  {
    super(props);
    this.state={
        ads:[],
    }
    this.ads_count=this.ads_count.bind(this);
  }
  componentDidMount()
  {
    if(localStorage.user_id)
    {
      var uid=localStorage.getItem('user_id')
    }
    else
    {
      uid=0;
    }
    var data1={'id':uid,'token':localStorage.getItem('token'),'width':400,'height':200,'from':4};
    var data2=JSON.stringify(data1);
    $.ajax({
        method:'POST',
        dataType:'json',
        url:baseUrl+'getAd',
        data:{req:data2},
        success:function(data)
        {
            this.setState({
              ads:data.imgs,
            });
        }.bind(this),
        error:function(err)
        {
          
        }
    });
  }
  ads_count(ad_id)
  {
     var uid = '';
     if(localStorage.user_id)
     {
        uid = localStorage.user_id;  
     }
     else
     {
        uid = localStorage.ip;
     }
     var data1 = {'from':4,'ad_id':ad_id,'id':uid};
     var data2=JSON.stringify(data1);
     $.ajax({
          method:'POST',
          dataType:'json',
          data:{req:data2},
          url:baseUrl+'load_ad',
          success:function(data)
          {

          },
          error:function(err)
          {
            
          }
      });
  }
  render(){
    var autoplay = "";
    if(this.state.ads.length > 0){
      autoplay = {
        delay: 5000,
        disableOnInteraction: false
      };
    }else{
      autoplay = false;
    }

    const params = {
        spaceBetween: 0,
        slidesPerView: 1,
      autoplay: autoplay,
        // pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplayDisableOnInteraction: false,
        // speed:1500,
        //effect: 'coverflow',
        // grabCursor: true,
        // centeredSlides: true,
        // coverflow: {
        //   rotate: 50,
        //   stretch: 0,
        //   depth: 100,
        //   modifier: 1,
        //   slideShadows : true
        // },
        // effect:'cube',
        // cube: {
        //     shadow: true,
        //     slideShadows: true,
        //     shadowOffset: 20,
        //     // shadowScale: 0.94
        //     shadowScale: 0
        //   },
        loop:true
      }

      var banners =this.state.ads.map(function(ad, index) {
                  var ad_deal = '';
                  var link='';
                  if(ad.link ==="")
                  {
                    link='';
                  }
                  else if(ad.link!=='')
                  {
                     link = ad.link;
                  }
                  if(ad.type === "Product")
                  {
                    ad_deal= "/subdeals/"+ad.url_dtype+"/"+ad.url_cat_name+"/"+ad.url_brand_name+"/"+ad.pid;
                  }
                  else if(ad.type === "All Seed Deals" && ad.id ==='0')
                  {
                    ad_deal="/seed";
                  }
                  else if(ad.type==="All Seed Deals" && ad.id > 0)
                  {
                    ad_deal="/seed/"+ad.url_dtype+"/"+ad.id;
                  }
                  else if (ad.type ==="p_sub_category")
                  {
                    var deal_ids='';
                    if(typeof(ad.deal_id)  != "undefined" && ad.deal_id != ''){
                      deal_ids = ad.deal_id;
                    }else{
                      deal_ids = '';
                    }                    
                    ad_deal="/pdeals/"+ad.url_dtype+"/"+ad.url_cat_name+"/"+ad.tid+"/Pcategory/"+ad.dtype+"/"+deal_ids;
                  }
                  else if(ad.type === "Pcategory")
                  {
                    ad_deal="/pdeals/"+ad.url_name+"/all/"+ad.id;
                  }
                  else if(ad.type ==="SeedDeals")
                  {
                    ad_deal="/sdetails/"+ad.url_dtype+"/"+ad.id;
                  }
                  else if(ad.type === "brand")
                  {
                    ad_deal = "/pdeals/"+ad.url_dtype+"/"+ad.url_ad_title+"/"+ad.tid+"/"+ad.type+"/"+ad.dtype;
                  }
                  else if(ad.type==="FeedDeals")
                  {
                    ad_deal="/pdetails/"+ad.url_dtype+"/"+ad.url_cat_name+"/"+ad.url_ad_title+"/"+ad.pid+"/"+ad.deal_id;
                  }
                  else if(ad.type === "Deal Offer Types")
                  {
                    ad_deal = "/pdeals/"+ad.url_dtype+"/"+ad.url_ad_title+"/"+ad.url_ad_type+"/offers/"+ad.id;
                  }
                  else if(ad.type === "All Product Deals")
                  {
                    ad_deal = "/offers/deals/"+ad.dis_val+"/"+ad.dis_opr+"/"+ad.dis_type;
                  }
                  else if(ad.type==="brand_details")
                  {
                    // ad_deal="/"+ad.bname+"/brand-details/"+ad.dtype+"/"+ad.bid;
                    ad_deal="/"+ad.bname+"/brand-details/"+ad.bid;
                  }
                  else if(ad.type==="PromoOffer")
                  {
                    ad_deal="/offerszone";
                  }
                  else if(ad.type==='partner')
                  {
                    ad_deal="/pdeals/partner/"+ad.tid;
                  }
                  else if(ad.type==='caa-approved' || ad.type==='ad-guarantee' || ad.type==='ad-assist')
                  {
                    if(ad.tid==='0')
                    {
                      ad_deal='/ad-banners/'+ad.type;
                    }
                    else
                    {
                      ad_deal="/stores/"+ad.type+'/'+ad.tid;  
                    }
                  }
                  else
                  {
                    ad_deal='/';
                  }
            return (
                <div key={index}>
                  <span className="mob_carousel_count swipe_caption">{ad.sno}/{this.state.ads.length}</span>
                   {link==='' ?  
                      <Link onClick={()=> this.ads_count(ad.ad_id)} to={ad_deal}>
                          <img src={ad.img ? baseAssets+"images/ad_imgs/XXHDPI/"+ad.img : baseAssets+'images/ad_imgs/placeholder_bg.png'}  style={{margin: '0 auto'}} alt="..."/>
                      </Link> : 
                      <a onClick={()=> this.ads_count(ad.ad_id)} href={link} target="_blank">
                        <img src={ad.img ? baseAssets+"images/ad_imgs/XXHDPI/"+ad.img : baseAssets+'images/ad_imgs/placeholder_bg.png'}  style={{margin: '0 auto'}} alt="..."/>
                      </a>
                    }
                  </div>)
            }.bind(this))
         
    return(
    	<div>
	      {this.state.ads.length > 0 ? 
		      <section className="pag_cntnt hm_pg_sld">
		          <Swiper {...params} key={this.state.ads.length}>
		               {banners}
		          </Swiper>
		      </section>	      
	      : ''}	
      </div>

    );
  }
}
  


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Common/BannerAds.js
 **/